import { render, staticRenderFns } from "./NewConversationEmptyState.vue?vue&type=template&id=04890cac&scoped=true&"
import script from "./NewConversationEmptyState.vue?vue&type=script&lang=js&"
export * from "./NewConversationEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./NewConversationEmptyState.vue?vue&type=style&index=0&id=04890cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04890cac",
  null
  
)

export default component.exports